import { findCompanyDetail } from "../../../infrastructure/repository/company-repository";
import Company from "../../../app/domain/Company";
import adaptCompanyFromDetail from "../../../infrastructure/adapters/adaptCompanyFromDetail";

export default async function fetchCompany({
  callback,
}: {
  callback(e: any): void;
}) {
  const { data } = await findCompanyDetail();
  callback(new Company(adaptCompanyFromDetail(data)));
}
